export const languages = [
  { languageCode: "de", languageName: "German" },
  { languageCode: "en", languageName: "English" },
  { languageCode: "fr", languageName: "French" },
  { languageCode: "zh", languageName: "Chinese" },
];
